import type {FC} from 'react';
import {externalLinkToHref} from 'utils';

import type {LinkSchema} from 'components/inline-link/schema';

import {InlineLinkDraft} from './draft';
import {InlineLinkRender} from './render';
import {InlineLinkServer} from './server';

interface Props {
	inlineLink?: LinkSchema;
	text: string;
	isDraft: boolean;
	className?: string;
}

export const InlineLink: FC<Props> = ({inlineLink, text, isDraft, className}: Props) => {
	if (!inlineLink) {
		return null;
	}

	if (inlineLink.type === 'external') {
		return (
			<InlineLinkRender
				href={externalLinkToHref(inlineLink.href)}
				targetBlank={inlineLink.targetBlank}
				text={text}
				className={className}
			/>
		);
	}

	if (inlineLink.type === 'internal') {
		return isDraft ? (
			<InlineLinkDraft inlineLink={{...inlineLink, text}} className={className} />
		) : (
			<InlineLinkServer inlineLink={{...inlineLink}} text={text} className={className} />
		);
	}

	return null;
};
